export type LLMServiceType = 'LLM_O1' | 'LLM_O1_MINI' | 'LLM_SONNET35' | 'LLM_HAIKU35'

export interface LLMCost {
  inputCost: number
  outputCost: number
}

export const LLM_DISPLAY_NAMES: Record<LLMServiceType, string> = {
  'LLM_O1': 'OpenAI o1',
  'LLM_O1_MINI': 'OpenAI o1 Mini',
  'LLM_SONNET35': 'Sonnet 3.5',
  'LLM_HAIKU35': 'Haiku 3.5'
}

export const LLM_COSTS: Record<LLMServiceType, LLMCost> = {
  'LLM_O1': { inputCost: 0.015, outputCost: 0.060 },
  'LLM_O1_MINI': { inputCost: 0.003, outputCost: 0.012 },
  'LLM_SONNET35': { inputCost: 0.003, outputCost: 0.015 },
  'LLM_HAIKU35': { inputCost: 0.0008, outputCost: 0.004 }
}